/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ReportingSetting } from '../../models/reporting-setting';

export interface ReportsGetDsnList$Params {
}

export function reportsGetDsnList(http: HttpClient, rootUrl: string, params?: ReportsGetDsnList$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<ReportingSetting>>> {
  const rb = new RequestBuilder(rootUrl, reportsGetDsnList.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<ReportingSetting>>;
    })
  );
}

reportsGetDsnList.PATH = '/reports/getDsnList';
